import { styled, Toolbar, Box } from '@mui/material';

export const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  backgroundColor: 'transparent',
  color: theme.palette.text.primary,
  minHeight: 56,
  padding: theme.spacing(0, 2),
  borderRadius: theme.shape.borderRadius,
  margin: theme.spacing(1, 0),
  gap: theme.spacing(1),
}));

export const ActionsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  alignItems: 'center',
  marginLeft: 'auto',
}));
